import { render, staticRenderFns } from "./EditRoleProductPopup.vue?vue&type=template&id=663aa918&scoped=true"
import script from "./EditRoleProductPopup.vue?vue&type=script&lang=js"
export * from "./EditRoleProductPopup.vue?vue&type=script&lang=js"
import style0 from "./EditRoleProductPopup.vue?vue&type=style&index=0&id=663aa918&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "663aa918",
  null
  
)

export default component.exports